// extracted by mini-css-extract-plugin
export default {"insetError":"Alert_insetError__umyS9","insetSuccess":"Alert_insetSuccess__INXLU","insetWarn":"Alert_insetWarn__+3eBq","insetBox":"Alert_insetBox__byZ8H"};